import { ControlPanelService } from './../../../../states/control-panel.service';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { ControlPanelStore } from 'src/states/control-panel.store';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-panel',
  templateUrl: './user-panel.component.html',
  styleUrls: ['./user-panel.component.scss']
})
export class UserPanelComponent implements OnDestroy {
  @Select(ControlPanelStore.userName$) userName$: Observable<string>;

  @Input()
  menuItems: any;

  @Input()
  menuMode: string;

  public UserName = '';

  u: Subscription;

  constructor(private translate: TranslateService) {
    this.u = this.userName$.subscribe( u => {
      this.UserName = u != null ? u : this.translate.instant('Guest');
    });
  }

  ngOnDestroy() {
    this.u?.unsubscribe();
  }
}
